'use client';

import type { CampaignImage } from '@/libs/campaigns/types';
import { useLocale } from 'next-intl';
import { getCampaignMessages } from '@/libs/campaigns/messages';
import { useActiveSkin } from '../ActiveCampaignProvider';

type CampaignLogo = {
  desktop: CampaignImage;
  mobile: CampaignImage;
  alt: string;
};

/** The Active Campaign's logo, or `null` to keep the default sprite logo. */
export function useCampaignLogo(): CampaignLogo | null {
  const skin = useActiveSkin();
  const locale = useLocale();

  if (!skin?.logo) {
    return null;
  }

  return {
    ...skin.logo,
    alt: getCampaignMessages(skin, locale).logoAlt,
  };
}
